import { useEffect, useState } from 'react'
import { Modal } from 'antd'
import {
  PlusCircleOutlined,
  DeleteOutlined,
  SketchOutlined,
  HeartFilled,
  HeartOutlined,
  UserOutlined
} from "@ant-design/icons"
import { toggleSongSheet } from "@/common/common"
import {
  Link,
  useNavigate,
  useSearchParams,
  useLocation
} from "react-router-dom"
import { togglePersonFlag } from "@/store/general"
import { useSnapshot } from "valtio"
import sheetStore, { removeSheet } from "@/store/mySheet"
import styles from "./css/slider.modules.less"

const Slider = () => {
  const [refresh, setRefresh] = useState(false) // 仅用作组件刷新
  const [modal, contextHolder] = Modal.useModal()
  const [search] = useSearchParams()
  const { sheetList } = useSnapshot(sheetStore)

  const sheetName = search.get('sheetName')
  const navigate = useNavigate()
  const { pathname } = useLocation()

  useEffect(() => {
    setRefresh(!refresh)
  }, [sheetList.length])
  // 歌单切换
  const sheetChange = val => {
    navigate(`/mySheet?sheetName=${val.name}`)
  }
  // 移除歌单
  const removeMySheet = val => {
    modal.confirm({
      title: `是否确认删除歌单--${val.name}`,
      okText: '确认',
      onOk() {
        removeSheet(val.name)
      },
      onCancel() {
        // console.log("Cancel")
      }
    })
  }
  // 去往私人歌单
  const goPerson = () => {
    let password = window.localStorage.getItem("mm")
    if (password == "zhj") togglePersonFlag()
    else {
      Modal.warning({
        title: '警告',
        content: '私人歌单，禁止观看哦！'
      })
    }
  }
  return (
    <div className={styles.sliderBox}>
      {contextHolder}
      <Link to="/home">
        <span className="slider-wrap">My music</span>
      </Link>
      {/* 两种多类名方式 */}
      <div
        className={['menu-list', pathname === '/hotSheet' && 'route-active'].join(' ')}
        onClick={() => navigate('/hotSheet')}
      >
        <SketchOutlined className="router-icon" />
        精品歌单
      </div>
      <div
        className={pathname === '/hotSinger' ? 'menu-list route-active' : 'menu-list'}
        onClick={() => navigate('/hotSinger')}
      >
        {/* <HeartFilled className="router-icon" /> */}
        <HeartOutlined className="router-icon" />
        热门歌手
      </div>
      <div
        className={pathname === '/myCollect' ? 'menu-list route-active' : 'menu-list'}
        onClick={() => navigate('/myCollect')}
      >
        {/* <HeartFilled className="router-icon" /> */}
        <HeartOutlined className="router-icon" />
        我的收藏
      </div>
      <div className="menu-list" onClick={goPerson}>
        <UserOutlined className="router-icon" />
        私人歌单
      </div>
      <p className="title">
        <span>我的歌单</span>
        <PlusCircleOutlined
          title="新建歌单"
          className="action-icon"
          onClick={() => toggleSongSheet(true, 'create')}
        />
      </p>
      <ul>
        {sheetList &&
          sheetList.map(item => (
            <li key={item.name} className={sheetName === item.name ? 'active' : ''}>
              <span title={item.name} className="sheet-txt" onClick={() => sheetChange(item)}>
                <i className="iconfont sheet-icon">&#xe618;</i>
                <span className="ov1">{item.name}</span>
              </span>
              <DeleteOutlined
                title="删除"
                className="delete-icon"
                onClick={() => removeMySheet(item)}
              />
            </li>
          ))}
      </ul>
    </div>
  )
}
export default Slider
